import { BillingCycle } from '../types/enums';

export const getCycleLabel = (cycle: BillingCycle) =>
  cycle === BillingCycle.MONTHLY
    ? 'mês'
    : cycle === BillingCycle.ANNUAL
      ? 'ano'
      : '';


